import styled from "styled-components";
import { Colors } from "~/config/Colors";

export const Menu = styled.div`
  position: relative;
  width: 4rem;
  height: 100%;
  color: ${Colors.Color13};
  background: ${Colors.Color2};
  transition: 0.5s;
  padding: 1rem 0.5rem 1rem 0.5rem;
  
  .menu-scroll {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding: 0.5rem 0rem 1rem 0rem;
    transition: 0.5s;
    height: 100%;

    ${({ showMaxMenu }) => {
      if (showMaxMenu) {
        return `overflow: initial; width: 100%;`;
      } else {
        return `width: 0rem; overflow: hidden;`;
      }
    }}

    .menu-button {
      width: 100%;
      margin-bottom: 0.8rem;
    }
  }
`;
